import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Checkbox from 'zignal-landscape/lib/Checkbox';
import Styles from './themes/WidgetSelection.css';

const WidgetSelection = ({
  isVisible = false,
  isSelected,
  onClick,
  widgetId
}) => {
  return isVisible ? (
    <div
      data-cy="widget-selection"
      className={classnames(Styles.wrapper, { [Styles.selected]: isSelected })}
      onClick={onClick}
    >
      <div className={Styles.checkbox}>
        <Checkbox
          data-cy="widget-selection-checkbox"
          id={`widget-selection-checkbox-${widgetId}`}
          checked={isSelected}
          onClick={(e) => e.stopPropagation()}
          name={`checkbox-${widgetId}`}
        />
      </div>
      <div className={Styles.overlay} />
    </div>
  ) : null;
};

WidgetSelection.propTypes = {
  isVisible: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  widgetId: PropTypes.string.isRequired
};

export default WidgetSelection;
